import { render, staticRenderFns } from "./KidsLifecycle.vue?vue&type=template&id=8eeb39e8&scoped=true"
import script from "./KidsLifecycle.vue?vue&type=script&lang=js"
export * from "./KidsLifecycle.vue?vue&type=script&lang=js"
import style0 from "./KidsLifecycle.vue?vue&type=style&index=0&id=8eeb39e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eeb39e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eeb39e8')) {
      api.createRecord('8eeb39e8', component.options)
    } else {
      api.reload('8eeb39e8', component.options)
    }
    module.hot.accept("./KidsLifecycle.vue?vue&type=template&id=8eeb39e8&scoped=true", function () {
      api.rerender('8eeb39e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/KidsLifecycle.vue"
export default component.exports